<template>
  <div class="container pa-5">
    <div class="row">
      <auto-complete-entity
        class="col"
        ref="jobCodeFilter"
        v-model="value.jobCode"
        entityApi="job"
        itemText="code"
        itemValue="code"
        :label="$t('components.regEdit.filters.jobCode')"
        prependIcon="mdi-find-replace"
      />
      <auto-complete-entity
        class="col"
        ref="resourceCodeFilter"
        v-model="value.resourceCode"
        entityApi="resource"
        itemText="description"
        itemValue="code"
        :label="$t('components.regEdit.filters.resourceCode')"
        prependIcon="mdi-find-replace"
      />
    </div>
    <div class="row">
      <auto-complete-entity
        class="col"
        ref="regTypeCodeFilter"
        v-model="value.regTypeCode"
        entityApi="regType"
        itemText="description"
        itemValue="code"
        :label="$t('components.regEdit.filters.regTypeCode')"
        prependIcon="mdi-find-replace"
        :multiple="true"
        @input="change"
      />
      <auto-complete-entity
        class="col"
        ref="userNameFilter"
        v-model="value.userName"
        entityApi="user"
        fieldApi="UserName"
        itemText="userName"
        itemValue="userName"
        :label="$t('components.regEdit.filters.user')"
        prependIcon="mdi-find-replace"
      />
    </div>
    <div class="row">
      <datetime-picker-dialog
        class="col"
        dateFormat="dd/MM/yy"
        :label="$t('components.regEdit.filters.dtStart')"
        v-model="value.dtStart"
      ></datetime-picker-dialog>
      <datetime-picker-dialog
        class="col"
        dateFormat="dd/MM/yy"
        :label="$t('components.regEdit.filters.dtEnd')"
        v-model="value.dtEnd"
      ></datetime-picker-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "reg-search-filter",
  props: {
    value: {
      default() {
        return {
          dtStart: null,
          dtEnd: null,
          jobCode: null,
          resourceCode: null,
          regTypeCode: [],
          userName: null,
          regFieldsArray: true,
        };
      },
    },
  },
  watch: {
    regTypeCode(value){
      console.log("regTypeCode >>> ", value)
    }
  },
  data() {
    return {};
  },
  methods: {
    change(value){
      console.log("CHANGE >>> ", value)
    }
  }
};
</script>
